import { render, staticRenderFns } from "./CustomWizardStep.vue?vue&type=template&id=1906fe7a&"
import script from "./CustomWizardStep.vue?vue&type=script&lang=js&"
export * from "./CustomWizardStep.vue?vue&type=script&lang=js&"
import style0 from "./CustomWizardStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports